import { SidebarRouter } from "../SidebarRouter"

import { DocumentContentRouter } from "./DocumentContentRouter"

export const DocumentContentRouterMobile = () => {

    return <>
        <SidebarRouter />
        <DocumentContentRouter />
    </>
}